import {
  InjectionToken, Provider, Type,
} from '@angular/core'

export const BaseLocationService = new InjectionToken<BaseLocationServiceInterface>('BaseLocationService')

export function provideBaseLocationService(service: Type<BaseLocationServiceInterface>): Provider {
  return {
    provide: BaseLocationService,
    useClass: service,
  }
}

export interface BaseLocationServiceInterface {
  readonly origin: string;
  readonly host: string;
  readonly hostname: string;
  readonly port: string;
  readonly protocol: string;
}
